var _g, _g2, _path, _path2, _path3, _path4, _path5, _g3, _path6, _path7, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSubscribe(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.45
  }, /*#__PURE__*/React.createElement("path", {
    d: "M200 99.7817C200 155.007 155.225 199.782 100 199.782C44.7748 199.782 0 155.007 0 99.7817",
    fill: "#00B7B0"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.66
  }, /*#__PURE__*/React.createElement("path", {
    d: "M191.782 99.7817C191.782 150.472 150.691 191.564 100 191.564C49.3093 191.564 8.2182 150.472 8.2182 99.7817",
    fill: "#00B7B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.2182 99.7818C8.2182 49.0911 49.3093 8 100 8C150.691 8 191.782 49.0911 191.782 99.7818",
    fill: "#00B7B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.2182 99.7818C8.2182 49.0911 49.3093 8 100 8C150.691 8 191.782 49.0911 191.782 99.7818",
    fill: "#00B7B0"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100 166.258C136.714 166.258 166.476 136.496 166.476 99.7817C166.476 63.0677 136.714 33.3052 100 33.3052C63.286 33.3052 33.5235 63.0677 33.5235 99.7817C33.5235 136.496 63.286 166.258 100 166.258Z",
    fill: "url(#paint0_linear_130_22713)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_130_22713",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 33,
    y: 33,
    width: 134,
    height: 134
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M166.476 33.3052H33.5235V166.258H166.476V33.3052Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_130_22713)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_130_22713",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 33,
    y: 33,
    width: 134,
    height: 134
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M166.476 33.3052H33.5235V166.258H166.476V33.3052Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_130_22713)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_130_22713",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 33,
    y: 33,
    width: 134,
    height: 134
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M100 166.258C136.717 166.258 166.476 136.498 166.476 99.7817C166.476 63.0649 136.717 33.3052 100 33.3052C63.2833 33.3052 33.5235 63.0649 33.5235 99.7817C33.5235 136.498 63.2833 166.258 100 166.258Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_130_22713)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_130_22713",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 16,
    width: 178,
    height: 153
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M188.629 16.0679H11.3613V168.721H188.629V16.0679Z",
    fill: "black"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_130_22713)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100 166.258C136.717 166.258 166.476 136.498 166.476 99.7817C166.476 63.0649 136.717 33.3052 100 33.3052C63.2833 33.3052 33.5235 63.0649 33.5235 99.7817C33.5235 136.498 63.2833 166.258 100 166.258Z",
    fill: "white"
  }))))))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M122.332 104.046L124.795 99.7817L122.332 95.5174L133.473 92.5344L138.268 74.6265L125.155 61.5134L107.247 66.3082L104.264 77.4494L100 74.9869L95.7357 77.4494L92.7527 66.3082L74.8448 61.5134L61.7317 74.6265L66.5265 92.5344L77.6676 95.5174L75.2052 99.7817L77.6676 104.046L66.5265 107.029L61.7317 124.937L74.8448 138.05L92.7527 133.245L95.7357 122.104L100 124.566L104.264 122.104L107.247 133.245L125.155 138.05L138.268 124.937L133.473 107.029L122.332 104.046ZM123.544 132.024L111.662 128.841L107.658 113.906L99.99 118.33L92.3323 113.906L88.3283 128.841L76.4464 132.024L67.7477 123.325L70.9309 111.443L80.4604 108.891L85.8658 107.439L81.4414 99.7717L85.8658 92.104L70.9309 88.1L67.7477 76.2181L76.4464 67.5194L88.3283 70.7026L92.3323 85.6375L99.99 81.2131L107.658 85.6375L111.662 70.7026L123.544 67.5194L132.242 76.2181L129.059 88.1L114.124 92.104L118.549 99.7717L114.124 107.439L129.059 111.443L132.242 123.325L123.544 132.024Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M100 93.7356L103.834 95.9478L106.046 99.7816L103.834 103.615L100 105.828L96.1661 103.615L93.9539 99.7816L96.1661 95.9478L100 93.7356Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_130_22713",
    x1: 100,
    y1: 159.692,
    x2: 100,
    y2: 26.7386,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008074"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#00897D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#00AAA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B7B0"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSubscribe);
export default __webpack_public_path__ + "static/media/iconSubscribe.36f4028514033e6c4324fde74d08729d.svg";
export { ForwardRef as ReactComponent };